import React, { useState, useEffect, useRef, useCallback } from "react";
import OlMap from "ol/Map";
import View from "ol/View";
import GeoJSON from "ol/format/GeoJSON.js";
import LayerGroup from "ol/layer/Group";
import TileLayer from "ol/layer/Tile";
import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import { transform } from "ol/proj";
import OSM from "ol/source/OSM";
import XYZ from "ol/source/XYZ";
import LayerSwitcher from "ol-layerswitcher";
import ImageWMS from "ol/source/ImageWMS";
import ImageLayer from "ol/layer/Image";
import {
  ScaleLine,
  FullScreen,
  Rotate,
  defaults as defaultControls,
} from "ol/control";
import Zoom from 'ol/control/Zoom';
import {
  DragRotateAndZoom,
  defaults as defaultInteractions,
} from "ol/interaction";
import { Circle as CircleStyle, Fill, Stroke, Style, Icon } from "ol/style";
import Feature from "ol/Feature";
import Point from "ol/geom/Point";
import Polygon from "ol/geom/Polygon";
import LineString from "ol/geom/LineString";
import Overlay from "ol/Overlay.js";
import "ol/ol.css";
import "reactjs-popup/dist/index.css";
import "ol-layerswitcher/dist/ol-layerswitcher.css";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { GeoJSON as GeoJSONFormat } from "ol/format";
import { bbox as bboxStrategy } from "ol/loadingstrategy.js";
import queryString from "query-string";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import axios from "axios";
import Text from "ol/style/Text.js";
import { fromLonLat } from "ol/proj";
import Alert from "@mui/material/Alert";
import Stack from "@mui/material/Stack";
import Snackbar from "@mui/material/Snackbar";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';
import { ShareLocation } from "./share-location";
import { ShareRoute } from "./share-route";
import {
  setCurrentLocation,
  closeRoadFetchStart,
} from "../../store/map/reducer";
import { CurrentLocationControl } from "./location";
import {
  setLocationStart,
  setSharedLocationStart,
} from "../../store/direction/reducer";
import * as colors from "@mui/material/colors";
import { GoogleLayerSwitcher } from "./google-layer-switcher";
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';

const pickLocationSource = new VectorSource();
const startMarkerSource = new VectorSource();
const endMarkerSource = new VectorSource();

const speedOneSource = new VectorSource();
const speedTwoSource = new VectorSource();
const speedThreeSource = new VectorSource();

const layerSpeedOneSource = new VectorLayer();
const layerSpeedTwoSource = new VectorLayer();
const layerSpeedThreeSource = new VectorLayer();

const styleOne = new Style();

const geoserver_url = "https://ssgi.edas.et/:8080/geoserver/wms";

const NorthArrow = document.createElement("img");
NorthArrow.setAttribute("src", "north-arrow.png");

export const PBFMap = (props) => {
  

  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const setLanguage = (lng) => {
    try {
      i18n.changeLanguage(lng);
      localStorage.setItem('lang', lng);
    } catch (e) {
      console.error('Failed to change language', e);
    }
  };
  const [pickedLocation, setPickedLocation] = useState();
  const [mapInstance, setMapInstance] = useState(null);

  const startLocationRef = useRef();
  const mapElement = useRef();
  const [input, setInput] = useState("");
  const [open, setOpen] = React.useState(false);
  const [openRoad, setOpenRoad] = React.useState(false);

  const {
    centerPoint,
    places,
    parcels,
    neighbourhoods,
    buildings,
    roads,
    activePlace,
    nearBy_places,
    closedRoads,
  } = useSelector((state) => state.map);
  const { pathUrls } = useSelector((state) => state.direction);

  useEffect(() => {
    dispatch(closeRoadFetchStart({}));
  }, []);
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };
  const handleCloseRoad = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenRoad(false);
  };
  useEffect(() => {
    if (pathUrls.length > 0) {
      if (pathUrls.data == []) {
        setOpenRoad(true);
      }
    }
  }, [pathUrls]);
  useEffect(() => {
    const standard = new TileLayer({
      title: t('Standard'),
      type: "base",
      visible: true,
      zIndex: 0,
    });

    const osm = new TileLayer({
      title: t('OSM'),
      type: "base",
      visible: false,
      zIndex: 0,
      source: new OSM(),
    });

    const mapboxsatelite = new TileLayer({
      source: new XYZ({
        url: "https://mt1.google.com/vt/lyrs=s&x={x}&y={y}&z={z}",
      }),
      title: t('Satellite'),
      visible: false,
      type: "base",
    });

    const terrain = new TileLayer({
      title: t('Terrain'),
      type: "base",
      visible: false,
      source: new XYZ({
        url: "https://mt1.google.com/vt/lyrs=p&x={x}&y={y}&z={z}",
      }),
    });

    const baseMaps = new LayerGroup({
      title: t('BaseLayers'),
      layers: [mapboxsatelite, terrain, osm, standard],
    });

    const closedRoad = new ImageWMS({
      //crossOrigin: "anonymous",
      serverType: "geoserver",
      params: {
        layers: "geoserver:road_close",
        tiled: true,
        VERSION: "1.1.0",

        TRANSPARENT: true,
      },
      url: "https://ssgi.edas.et/:8080/geoserver/wms?",
    });
    const closeRoadWMS = new ImageLayer({
      // title: "Bishoftu Boundary",
      source: closedRoad,
      projection: 'EPSG:4326',
    });
    const bishoftuSource = new ImageWMS({
      //crossOrigin: "anonymous",
      serverType: "geoserver",
      params: {
        layers: "geoserver:bishoftu_aoi",
        tiled: true,
        VERSION: "1.1.0",

        TRANSPARENT: true,
      },
      url: "https://ssgi.edas.et/:8080/geoserver/wms?",
    });
    const bishoftuWMS = new ImageLayer({
      // title: "Bishoftu Boundary",
      source: bishoftuSource,
      name: "building",
      projection: 'EPSG:4326',
    });

    const ethSource = new ImageWMS({
      //crossOrigin: "anonymous",
      serverType: "geoserver",
      params: {
        layers: "geoserver:eth_aoi",
        tiled: true,
        VERSION: "1.1.0",

        TRANSPARENT: true,
      },
      url: geoserver_url,
    });
    const ethWMS = new ImageLayer({
      // title: "Eth Boundary",
      source: ethSource,
      projection: 'EPSG:4326',
    });

    const buildingLayerSource = new ImageWMS({
      //crossOrigin: "anonymous",
      serverType: "geoserver",
      params: {
        layers: "geoserver:building_web_v7",
        tiled: true,
        VERSION: "1.1.0",

        TRANSPARENT: true,
      },
      url: geoserver_url,
    });
    const buildingWmsLayer = new ImageLayer({
      title: "Building",

      source: buildingLayerSource,
      projection: 'EPSG:4326',
    });

    const citiesLayerSource = new ImageWMS({
      //crossOrigin: "anonymous",
      serverType: "geoserver",
      params: {
        layers: "geoserver:cities_web_v7",
        tiled: true,
        VERSION: "1.1.0",

        TRANSPARENT: true,
      },
      url: geoserver_url,
    });
    const citiesWmsLayer = new ImageLayer({
      // title: "Cities",
      source: citiesLayerSource,
      projection: 'EPSG:4326',
      visible: i18n.language !== 'am',
    });


     const citiesAmLayerSource = new ImageWMS({
      //crossOrigin: "anonymous",
      serverType: "geoserver",
      params: {
        layers: "geoserver:cities_Am_web_v7",
        tiled: true,
        VERSION: "1.1.0",

        TRANSPARENT: true,
      },
      url: geoserver_url,
    });
    const citiesAmWmsLayer = new ImageLayer({
      // title: "Cities",
      source: citiesAmLayerSource,
      projection: 'EPSG:4326',
      visible: i18n.language === 'am',
    });

      const citiesOrLayerSource = new ImageWMS({
      //crossOrigin: "anonymous",
      serverType: "geoserver",
      params: {
        layers: "geoserver:cities_Or_web_v7",
        tiled: true,
        VERSION: "1.1.0",

        TRANSPARENT: true,
      },
      url: geoserver_url,
    });
    const citiesOrWmsLayer = new ImageLayer({
      // title: "Cities",
      source: citiesOrLayerSource,
      projection: 'EPSG:4326',
      visible: i18n.language === 'am',
    });

    const drivingDirectionLayerSource = new ImageWMS({
      //crossOrigin: "anonymous",
      serverType: "geoserver",
      params: {
        layers: "geoserver:driving_direction",
        tiled: true,
        VERSION: "1.1.0",

        TRANSPARENT: true,
      },
      url: geoserver_url,
    });
    const drivingDirectionWmsLayer = new ImageLayer({
      // title: "Driving Direction",
      source: drivingDirectionLayerSource,
      projection: 'EPSG:4326',
    });

    const ethLayerSource = new ImageWMS({
      //crossOrigin: "anonymous",
      serverType: "geoserver",
            zIndex: 10, // Ensure geoserver data is always on top

      params: {
        layers: "geoserver:eth_aoi",
        tiled: true,
        VERSION: "1.1.0",

        TRANSPARENT: true,
      },
      url: geoserver_url,
     
    });
    const ethWmsLayer = new ImageLayer({
      // title: "Ethio Boundary",
      source: ethLayerSource,
      projection: 'EPSG:4326',
    });

    const landmarklayer = new ImageWMS({
      //crossOrigin: "anonymous",
      serverType: "geoserver",
      params: {
        layers: "geoserver:landmark_web_v7",
        tiled: true,
        VERSION: "1.1.0",

        TRANSPARENT: true,
        // CQL_FILTER: "status='Pending'",

      },
      url: geoserver_url,
    });
    var wmsLayer = new ImageLayer({
      title: t('Landmarks'),
      name: "landmarks",
      source: landmarklayer,
      projection: 'EPSG:4326',
    });

     const landmarkAmlayer = new ImageWMS({
      //crossOrigin: "anonymous",
      serverType: "geoserver",
      params: {
        layers: "geoserver:landmark_Am_web_v7",
        tiled: true,
        VERSION: "1.1.0",

        TRANSPARENT: true,
      },
      url: geoserver_url,
    });
    var wmsLayerAm = new ImageLayer({
      title: t('Landmarks'),
      name: "landmarks",
      source: landmarkAmlayer,
      projection: 'EPSG:4326',
    });






    const landUselayer = new ImageWMS({
      crossOrigin: "anonymous",
      serverType: "geoserver",
      params: {
        layers: "geoserver:lulc_v7",
        tiled: true,
        VERSION: "1.1.0",

        TRANSPARENT: true,
      },
      url: geoserver_url,
    });
    const wmsLandUseLayer = new ImageLayer({
      title: t('LandUse'),
      name: "landuse",
      source: landUselayer,
      projection: 'EPSG:4326',
    });

    const nhLayerSource = new ImageWMS({
      //crossOrigin: "anonymous",
      serverType: "geoserver",
      params: {
        layers: "geoserver:nh_aoi_web_v7",
        tiled: true,
        VERSION: "1.1.0",

        TRANSPARENT: true,
      },
      url: geoserver_url,
    });
    const nhWmsLayer = new ImageLayer({
      title: t('Neighborhood'),
      name: "neighborhood",
      source: nhLayerSource,
      projection: 'EPSG:4326',
    });

    const paRoadsLayerSource = new ImageWMS({
      //crossOrigin: "anonymous",
      serverType: "geoserver",
      params: {
        layers: "geoserver:pa_roads",
        tiled: true,
        VERSION: "1.1.0",

        TRANSPARENT: true,
      },
      url: geoserver_url,
    });
    const paRoadsWmsLayer = new ImageLayer({
      title: t('Roads'),
      name: "roads",
      source: paRoadsLayerSource,
      projection: 'EPSG:4326',
    });

    const parcelLayerSource = new ImageWMS({
      //crossOrigin: "anonymous",
      serverType: "geoserver",
      params: {
        layers: "geoserver:parcel_web_v7",
        tiled: true,
        VERSION: "1.1.0",

        TRANSPARENT: true,
      },
      url: geoserver_url,
    });
    const parcelWmsLayer = new ImageLayer({
      title: t('Parcel'),
      name: "parcel",
      source: parcelLayerSource,
      projection: 'EPSG:4326',
    });
    const roadPolygonprincipalLayerSource = new ImageWMS({
      //crossOrigin: "anonymous",
      serverType: "geoserver",
      params: {
        layers: "geoserver:road_polygon_v7_principal",
        tiled: true,
        VERSION: "1.1.0",

        TRANSPARENT: true,
      },
      url: geoserver_url,
    });
    const roadPolygonprincipalWmsLayer = new ImageLayer({
      // title: "Road polygon principal",
      source: roadPolygonprincipalLayerSource,
      name: "roads",
      projection: 'EPSG:4326',
    });
    const roadPolygonLayerSource = new ImageWMS({
      //crossOrigin: "anonymous",
      serverType: "geoserver",
      params: {
        layers: "geoserver:road_polygon_web_v7",
        tiled: true,
        VERSION: "1.1.0",

        TRANSPARENT: true,
      },
      url: geoserver_url,
    });
    const roadPolygonWmsLayer = new ImageLayer({
      // title: "Road polygon",
      source: roadPolygonLayerSource,
      name: "roads",
      projection: 'EPSG:4326',
    });






    const roadSignsLayerSource = new ImageWMS({
      //crossOrigin: "anonymous",
      serverType: "geoserver",
      params: {
        layers: "geoserver:road_signs",
        tiled: true,
        VERSION: "1.1.0",

        TRANSPARENT: true,
      },
      url: geoserver_url,
    });
    const roadSignsWmsLayer = new ImageLayer({
      // title: "Road Signs",
      source: roadSignsLayerSource,
      projection: 'EPSG:4326',
    });

    const roadRetworkLayerSource = new ImageWMS({
      //crossOrigin: "anonymous",
      serverType: "geoserver",
      params: {
        layers: "geoserver:das_road_network",
        tiled: true,
        VERSION: "1.1.0",

        TRANSPARENT: true,
      },
      url: geoserver_url,
    });
    const roadRetworkWmsLayer = new ImageLayer({
      // title: "Road network",
      source: roadRetworkLayerSource,
      name: "roads",
      projection: 'EPSG:4326',
    });

    const vector = new VectorLayer({
      source: new VectorSource({
        url: "https://ssgi.edas.et/:8080/geoserver/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=geoserver:landmark&outputFormat=application/json",
        format: new GeoJSON(),
      }),
      projection: 'EPSG:4326',
      style: new Style({
        image: new CircleStyle({
          radius: 6,
          fill: new Fill({
            color: "transparent",
          }),
        }),
      }),
    });

    const vectorParcel = new VectorLayer({
      source: new VectorSource({
        url: "https://ssgi.edas.et/:8080/geoserver/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=geoserver:parcel_v7&outputFormat=application/json",
        format: new GeoJSON(),
      }),
      projection: 'EPSG:4326',
      style: new Style({
        stroke: new Stroke({
          color: 'transparent', // Stroke color for the polygon outline
          width: 2, // Stroke width for the polygon outline
        }),
        fill: new Fill({
          color: 'transparent', // Fill color for the polygon
        }),
      }),
    });

     
    const featureLayer = new LayerGroup({
      title: "Overlays",
      zIndex: -10, // Ensure geoserver data is always on top
      layers: [
        ethWmsLayer,
        bishoftuWMS,
        wmsLandUseLayer,
        parcelWmsLayer,
        roadPolygonWmsLayer,
        roadPolygonprincipalWmsLayer,
        buildingWmsLayer,
        nhWmsLayer,
        paRoadsWmsLayer,
        roadRetworkWmsLayer,
        citiesWmsLayer,
        citiesAmWmsLayer,
        citiesOrWmsLayer,
        roadSignsWmsLayer,
        drivingDirectionWmsLayer,
        wmsLayer,
        wmsLayerAm,
        vectorParcel,
        vector,
        closeRoadWMS
      ],
    });


    // const center = [38.97735, 9.74975];
    // const center = [42.12683836966125, 9.306213446378933];

    const center = [38.97735, 9.74975];
    window.initialMap = new OlMap({
      target: mapElement.current,
      layers: [baseMaps, featureLayer,ethWmsLayer],
      view: new View({
        center: center,
        zoom: 6.5,
        projection: "EPSG:4326",
      }),
      controls: defaultControls({ zoom: false }).extend([
        new ScaleLine(),
        new FullScreen({ tipLabel: t('FullScreen') }),
        new Zoom({ zoomInTipLabel: t('ZoomIn'), zoomOutTipLabel: t('ZoomOut') }),
        new CurrentLocationControl({ tipLabel: t('CurrentLocation') }),
              ]),
      interactions: defaultInteractions().extend([new DragRotateAndZoom()]),
    });

    // const layerSwitcher = new LayerSwitcher({
    //   reverse: true,
    //   groupSelectStyle: "group",
    // });

    // window.initialMap.addControl(layerSwitcher);
    setMapInstance(window.initialMap);

    // Toggle cities layer when language changes
    (function () {
      try {
        const langHandler = function (lng) {
          try {
            // citiesWmsLayer.setVisible(lng !== 'am');
            citiesWmsLayer.setVisible(lng === 'en');
            citiesAmWmsLayer.setVisible(lng === 'am' ||  lng === 'had' || lng ==="tig");


            wmsLayer.setVisible(lng !== 'am' ||  lng !== 'had' ||lng ==="tig");
            wmsLayerAm.setVisible(lng !== 'en' ||  lng !== 'or');

            wmsLayerAm.setVisible(lng === 'am' ||  lng === 'had' || lng ==="tig");
            wmsLayer.setVisible(lng === 'en' ||  lng === 'or');


            citiesOrWmsLayer.setVisible(lng === 'or');
            // citiesAmWmsLayer.setVisible(lng === 'had');
          
          } catch (e) {
            console.error('Failed to toggle cities layers for language', e);
          }
        };

        // initial sync (in case i18n.language changed after creation)
        langHandler(i18n.language || 'en');
        i18n.on('languageChanged', langHandler);

        // cleanup when component unmounts
        const cleanup = () => {
          try {
            i18n.off('languageChanged', langHandler);
          } catch (e) {}
        };
        // store cleanup to window for dev reloads (safe noop otherwise)
        window.__mapLangCleanup = cleanup;
      } catch (e) {
        console.error('Failed to attach language handler for cities layer', e);
      }
    })();

    // position selected map controls 50px from the bottom of the map
    (function () {
      try {
        const root = mapElement.current;
        if (!root) return;
        const selectors = [
          '.ol-full-screen',
          // '.ol-zoom',
          // '.ol-rotate',
          // '.current-location',
        ];
        selectors.forEach((sel) => {
          const el = root.querySelector(sel);
          if (el) {
            el.style.position = 'absolute';
            el.style.bottom = '225px';
          }
        });
         const selectors2 = [
          // '.ol-full-screen',
          // '.ol-zoom',
          // '.ol-rotate',
          '.current-location',
        ];
        selectors2.forEach((sel) => {
          const el = root.querySelector(sel);
          if (el) {
            el.style.position = 'absolute';
            el.style.bottom = '200px';
          }
        });
        const selectors1 = [
         
          '.ol-zoom',
          // '.ol-rotate',
          // '.current-location',
        ];
        selectors1.forEach((sel) => {
          const el = root.querySelector(sel);
          if (el) {
            el.style.position = 'absolute';
            el.style.bottom = '250px';
          }
        });
      } catch (e) {
        console.error('Failed to adjust control positions', e);
      }
    })();

    const container = document.getElementById("popup");
    const content = document.getElementById("popup-content");
    const closer = document.getElementById("popup-closer");
    const details = document.getElementById("details");
    const accordion = document.getElementById("popup-accordion");
    const emptyFeature = document.getElementById("empty-feature");

    window.popupOverlay = new Overlay({
      element: container,
      autoPan: {
        animation: {
          duration: 250,
        },
      },
      stopEvent: true,
    });

    // single close handler: hide overlay, clear content and details
    if (closer) {
      closer.addEventListener('click', function (evt) {
        try {
          evt.preventDefault();
        } catch (e) {}
        if (window.popupOverlay) {
          window.popupOverlay.setPosition(undefined);
        }
        if (content) content.innerHTML = '';
        if (details) details.innerHTML = '';
        if (accordion) accordion.style.display = 'none';
        if (emptyFeature) emptyFeature.style.display = 'none';
        try { closer.blur(); } catch (e) {}
      });
    }
    // Add overlay to the map once (do not add on every click)
    if (window.initialMap && window.popupOverlay) {
      window.initialMap.addOverlay(window.popupOverlay);
    }

    // Image viewer wiring: expose a global helper to open images full-screen
    (function () {
      const imageViewer = document.getElementById('image-viewer');
      const imageViewerImg = document.getElementById('image-viewer-img');
      const imageViewerClose = document.getElementById('image-viewer-close');

      window.openPopupImage = function (url) {
        try {
          if (!url) return;
          if (imageViewerImg) imageViewerImg.src = url;
          if (imageViewer) imageViewer.style.display = 'flex';
        } catch (e) {
          console.error(e);
        }
      };

      if (imageViewerClose) {
        imageViewerClose.addEventListener('click', function () {
          if (imageViewer) imageViewer.style.display = 'none';
          if (imageViewerImg) imageViewerImg.src = '';
        });
      }

      if (imageViewer) {
        imageViewer.addEventListener('click', function (evt) {
          if (evt.target === imageViewer) {
            imageViewer.style.display = 'none';
            if (imageViewerImg) imageViewerImg.src = '';
          }
        });
      }

      document.addEventListener('keydown', function (evt) {
        if (evt.key === 'Escape') {
          if (imageViewer) imageViewer.style.display = 'none';
          if (imageViewerImg) imageViewerImg.src = '';
        }
      });
    })();
    window.initialMap.on("singleclick", function (e) {



      window.popupOverlay.setPosition(undefined);
      // REST TO DEFAULT STYLE
      content.innerHTML = "";
      accordion.style.display = "block";
      emptyFeature.style.display = "none";

      const feature = window.initialMap.forEachFeatureAtPixel(
        e.pixel,
        function (feature) {
          return feature;
        }
      );

      if (feature && feature.values_) {
        const coordinate = feature.getGeometry().getCoordinates();

        // Build a single preview image (if available)
        let firstImageUrl = '';
        try {
          if (feature.values_.image && feature.values_.image.trim() !== '') {
            const imgs = Object.values(JSON.parse(feature.values_.image));
            if (imgs && imgs.length) firstImageUrl = `http://196.189.124.150:4000/${imgs[0]}`;
          }
        } catch (err) {
          console.warn('Failed to parse feature images', err);
        }
        const safeFirstImageUrl = (firstImageUrl || '').replace(/'/g, "\\'");

        // Expose a small helper so inline buttons can copy text reliably
        window.copyPopupText = function (text) {
          try {
            if (!text) return;
            navigator.clipboard.writeText(text);
            // simple feedback
            alert('Copied');
          } catch (e) {
            console.error(e);
          }
        };

        // Style popup container (rounded, shadow)
        if (container) {
          container.style.borderRadius = '12px';
          container.style.boxShadow = '0 10px 30px rgba(0,0,0,0.12)';
          container.style.padding = '15px';
          container.style.background = '#fff';
          container.style.maxWidth = '460px';
          container.style.overflow = 'hidden';
          container.style.fontFamily = 'Arial, Helvetica, sans-serif';
        }

        // Style closer
        // if (closer) {
        //   closer.innerHTML = '✕';
        //   closer.style.color = '#1a73e8';
        //   closer.style.fontSize = '20px';
        //   closer.style.textDecoration = 'none';
        //   closer.style.position = 'absolute';
        //   closer.style.top = '1px';
        //   closer.style.right = '2px';
        // }

        const title = feature.values_.name_eng || feature.values_.name || '';
        const subTitle = feature.values_.Building_amh || feature.values_.legal_name || '';
        const locationText = feature.values_.city_name || feature.values_.City_Name || '';
        const typeText = feature.values_.fun_type || feature.values_.category || '';
        const zoneText = feature.values_.zone_sub_c || feature.values_.zone || 'N/A';
        const woredaText = feature.values_.woreda || 'N/A';
        const houseNo = feature.values_.building_u || feature.values_.Building_UID || 'N/A';

        content.innerHTML = `
          <div style="position:relative;padding:8px 6px 6px 6px">
            <div style="display:flex;gap:12px;align-items:flex-start">
              <div style="flex:0 0 120px">
                ${firstImageUrl ? `<img src="${firstImageUrl}" alt="${title}" onclick="window.openPopupImage('${safeFirstImageUrl}')" style="cursor:pointer;width:120px;height:100px;object-fit:cover;border-radius:8px;box-shadow:0 4px 10px rgba(0,0,0,0.08)"/>` : `<div style="width:120px;height:100px;border-radius:8px;background:#f5f5f5;display:flex;align-items:center;justify-content:center;color:#9e9e9e">${t('NoImage')}</div>`}
              </div>
              <div style="flex:1;min-width:0">
                <div style="color:#1a73e8;font-weight:700;font-size:18px;line-height:1.1;margin-bottom:6px">${title}</div>
                <div style="color:#757575;font-size:13px;margin-bottom:10px">${subTitle}</div>

                <div style="display:flex;gap:8px;margin-bottom:10px">
                  <div style="background:#f1f7ff;border-left:4px solid #1976d2;padding:8px;border-radius:6px;flex:1">
                    <div style="font-size:12px;color:#666">${t('Location')}:</div>
                    <div style="font-weight:600;font-size:13px">${locationText || 'N/A'}</div>
                  </div>
                  <div style="background:#fff8f0;border-left:4px solid #ffb74d;padding:8px;border-radius:6px;flex:1">
                    <div style="font-size:12px;color:#666">${t('Type')}:</div>
                    <div style="font-weight:600;color:#1976d2;font-size:13px">${typeText || 'N/A'}</div>
                  </div>
                </div>

                <div style="font-size:14px;color:#424242;margin-bottom:10px">
                  <div><b>${t('Zone')}:</b> ${zoneText}</div>
                  <div><b>${t('Woreda')}:</b> ${woredaText}</div>
                </div>

                <div style="margin-top:6px;display:flex;align-items:center;gap:10px">
                  <div style="font-size:15px;color:#1976d2"><b>${t('HouseNo')}:</b> <span style="margin-left:6px;color:#1976d2;font-weight:600">${houseNo}</span></div>
                  <button onclick="window.copyPopupText(\"${(houseNo+'').replace(/\\\"/g, '\\\\"')}\")" style="border:1px solid #1976d2;background:#ffffff;color:#1976d2;padding:6px 10px;border-radius:8px;cursor:pointer">${t('COPY')}</button>
                </div>
              </div>
            </div>
          </div>
        `;

        // Show only images in the details pane (thumbnail grid)
        (function () {
          let imgsHtml = '';
          try {
            if (feature.values_.image && feature.values_.image.trim() !== '') {
              const imgs = Object.values(JSON.parse(feature.values_.image));
              if (imgs && imgs.length) {
                imgsHtml = imgs.map(img => {
                  const url = `http://196.189.124.150:4000/${img}`;
                  const esc = url.replace(/'/g, "\\'");
                  return `<div style="flex:0 0 120px;">
                            <img src="${url}" onclick="window.openPopupImage('${esc}')" style="cursor:pointer;width:120px;height:90px;object-fit:cover;border-radius:8px;box-shadow:0 4px 8px rgba(0,0,0,0.08)"/>
                          </div>`;
                }).join('');
              }
            }
          } catch (err) {
            console.warn('Failed to parse images for details pane', err);
          }

          if (!imgsHtml) {
            details.innerHTML = `<div style="padding:12px;color:#777;font-size:14px">${t('NoImagesAvailable')}</div>`;
          } else {
            details.innerHTML = `
              <div style="display:flex;flex-wrap:wrap;gap:10px;padding:8px">
                ${imgsHtml}
              </div>
            `;
          }
        })();

        window.popupOverlay.setPosition(coordinate);
      }
      // overlay already added to map during initialization
    });
  }, []);
  useEffect(() => {
    let num = window.initialMap.getLayers().getLength();
    console.log(num);
    while (num > 2) {
      window.initialMap.getLayers().pop();
      num--;
    }
    props.setPath_datas([]);
  }, [props.activeTab]);
  useEffect(() => {
    console.log("kkkk", window.initialMap.getLayers().getLength())
  })
  useEffect(() => {
    window.popupOverlay.setPosition(undefined);
    if (parcels.length) {
      const searchPrsels = [];
      parcels.forEach((e) => {
        const feature = new Feature({
          geometry: new Polygon(e.geometry.coordinates[0]),
          name: "Parcel Code " + e.properties.prcl_code,
          Building_amh: "Neigbourhood " + e.properties.neighborho,
          City_Name: "Parcel Unit " + e.properties.parcel_uni,
        });
        searchPrsels.push(feature);
      });

      const vectorLayer = new VectorLayer({
        source: new VectorSource({
          features: searchPrsels,
        }),
        projection: 'EPSG:4326',
        style: new Style({
          stroke: new Stroke({
            color: colors.blue[800],
            width: 3,
          }),
        }),
        zIndex: 9999,
      });

      window.initialMap.getLayers().forEach((layer) => {
        if (layer instanceof VectorLayer) {
          window.initialMap.removeLayer(layer);
        }
      });

      window.initialMap.addLayer(vectorLayer);
    }

    if (neighbourhoods.length) {
      const searchedNeighbourhoods = [];
      neighbourhoods.forEach((e) => {
        const feature = new Feature({
          geometry: new Polygon(e.geom.coordinates[0]),
          name: "Neighbourhood Code " + e.nh_code,
        });
        searchedNeighbourhoods.push(feature);
      });

      const vectorLayer = new VectorLayer({
        source: new VectorSource({
          features: searchedNeighbourhoods,
        }),
        projection: 'EPSG:4326',
        style: new Style({
          stroke: new Stroke({
            color: colors.blue[800],
            width: 3,
          }),
        }),
        zIndex: 9999,
      });

      window.initialMap.getLayers().forEach((layer) => {
        if (layer instanceof VectorLayer) {
          window.initialMap.removeLayer(layer);
        }
      });

      window.initialMap.addLayer(vectorLayer);
    }

    if (buildings.length) {
      const searchBuildings = [];
      buildings.forEach((e) => {
        const d = e.geometry.coordinates[0][0][0];
        const feature = new Feature({
          geometry: new Point(d),
          name: "Building ID " + e.id,
        });
        searchBuildings.push(feature);
      });

      const vectorLayer = new VectorLayer({
        source: new VectorSource({
          features: searchBuildings,
        }),
        projection: 'EPSG:4326',
        style: new Style({
          image: new Icon({
            anchorXUnits: "fraction",
            anchorYUnits: "fraction",
            src: "6.png",
          }),
        }),
        zIndex: 9999,
      });

      window.initialMap.getLayers().forEach((layer) => {
        if (layer instanceof VectorLayer) {
          window.initialMap.removeLayer(layer);
        }
      });

      window.initialMap.addLayer(vectorLayer);
    }

    if (roads.length) {
      const searchRoads = [];
      roads.forEach((e) => {
        const d = e.geometry.coordinates;
        const feature = new Feature({
          geometry: new LineString(d),
          name: "Road Id " + e.properties.road_uid,
          Building_amh: e.properties.type,
          City_Name: +e.properties.road_weath,
        });
        searchRoads.push(feature);
      });

      const vectorLayer = new VectorLayer({
        source: new VectorSource({
          features: searchRoads,
        }),
        projection: 'EPSG:4326',
        style: new Style({
          stroke: new Stroke({
            color: colors.blue[800],
            width: 5,
          }),
        }),
        zIndex: 9999,
      });

      window.initialMap.getLayers().forEach((layer) => {
        if (layer instanceof VectorLayer) {
          window.initialMap.removeLayer(layer);
        }
      });

      window.initialMap.addLayer(vectorLayer);
    }


    if (places.length) {
      const searchByName = [];
      places.forEach((e) => {
        const d = e.geometry.coordinates;
        const feature = new Feature({
          geometry: new Point(d),
          name: e.properties.name_eng,
          Building_UID: e.properties.building_u,
          Building_L: d,
          Building_N: e.properties.building_n,
          Building_amh: e.properties.legal_name,
          Building_oro: e.properties.legal_na_2,
          category: e.properties.fun_type,
          region: e.properties.region,
          City_Name: e.properties.city_name,
          Parking_Facility: e.properties.parking_fa,
          Village_Na: e.properties.village_na,
          image: e.properties.image,
        });

        feature.setStyle(
          new Style({
            image: new Icon({
              scale: 0.6,
              anchorXUnits: "fraction",
              anchorYUnits: "fraction",
              src: centerPoint === e.id ? "green.png" : "blue.png",
            }),
          })
        );

        searchByName.push(feature);
      });
      const vectorLayer = new VectorLayer({
        source: new VectorSource({
          features: searchByName,
        }),
        projection: 'EPSG:4326'
        ,
        zIndex: 9999
      });
      window.initialMap.getLayers().forEach((layer) => {
        if (layer instanceof VectorLayer) {
          window.initialMap.removeLayer(layer);
        }
      });
      window.initialMap.addLayer(vectorLayer);
      if (places.length >= 2) {
        window.initialMap.getView().fit(vectorLayer.getSource().getExtent(), {
          padding: [100, 100, 100, 100],
        });
      }
    }

    if (nearBy_places.length) {
      const searchByName = [];
      nearBy_places.forEach((e) => {
        const d = e.geometry.coordinates;
        const feature = new Feature({
          geometry: new Point(d),
          name: e.properties.name_eng,
          Building_UID: e.properties.building_u,
          Building_L: d,
          Building_N: e.properties.building_n,
          Building_amh: e.properties.legal_name,
          Building_oro: e.properties.legal_na_2,
          category: e.properties.function_t,
          region: e.properties.region,
          City_Name: e.properties.city_name,
          Parking_Facility: e.properties.parking_fa,
          Village_Na: e.properties.village_na,
          image: e.properties.image,
        });

        feature.setStyle(
          new Style({
            image: new Icon({
              scale: 0.6,
              anchorXUnits: "fraction",
              anchorYUnits: "fraction",
              src: centerPoint === e.id ? "green.png" : "blue.png",
            }),
          })
        );

        searchByName.push(feature);
      });
      const vectorLayer = new VectorLayer({
        source: new VectorSource({
          features: searchByName,
        }),
        projection: 'EPSG:4326'
        ,
        zIndex: 9999
      });
      window.initialMap.getLayers().forEach((layer) => {
        if (layer instanceof VectorLayer) {
          window.initialMap.removeLayer(layer);
        }
      });
      window.initialMap.addLayer(vectorLayer);
      if (places.length >= 2) {
        window.initialMap.getView().fit(vectorLayer.getSource().getExtent(), {
          padding: [100, 100, 100, 100],
        });
      }
    }
  }, [places, neighbourhoods, parcels, buildings, roads, nearBy_places]);
  // Separate useEffect for closed roads
  useEffect(() => {
    console.log('Closed roads data:', closedRoads);
    console.log('Closed roads length:', closedRoads.length);
    console.log('Available roads data:', roads);

    if (closedRoads.length && roads.length) {
      const closedRoadFeatures = [];

      closedRoads.forEach((closedRoad, index) => {
        console.log(`Processing closed road ${index}:`, closedRoad);

        // Find the corresponding road in the roads array using roadUid
        const matchingRoad = roads.find(road =>
          road.properties && road.properties.road_uid === closedRoad.roadUid
        );

        if (matchingRoad && matchingRoad.geometry && matchingRoad.geometry.coordinates) {
          console.log(`Found matching road for ${closedRoad.roadUid}:`, matchingRoad);

          const feature = new Feature({
            geometry: new LineString(matchingRoad.geometry.coordinates),
            road_uid: closedRoad.roadUid,
            name: "Closed Road " + closedRoad.roadUid,
            status: closedRoad.status,
            startDate: closedRoad.startDate,
            endDate: closedRoad.endDate,
          });
          closedRoadFeatures.push(feature);
          console.log(`Added closed road feature ${index} for ${closedRoad.roadUid}`);
        } else {
          console.log(`No matching road found for closed road ${closedRoad.roadUid}`);
          console.log('Available road UIDs:', roads.map(r => r.properties?.road_uid));
        }
      });

      console.log('Total closed road features created:', closedRoadFeatures.length);

      if (closedRoadFeatures.length > 0) {
        const closedRoadLayer = new VectorLayer({
          source: new VectorSource({
            features: closedRoadFeatures,
          }),
          projection: 'EPSG:4326',
          style: new Style({
            stroke: new Stroke({
              color: colors.red[600],
              width: 5,
            }),
          }),
          zIndex: 1000, // Ensure closed roads appear on top
        });

        console.log('Adding closed road layer to map');
        window.initialMap.addLayer(closedRoadLayer);
        console.log('Closed road layer added successfully');
      } else {
        console.log('No closed road features to display');
      }
    } else {
      if (!closedRoads.length) {
        console.log('No closed roads data available');
      }
      if (!roads.length) {
        console.log('No roads data available for geometry lookup');
      }
    }
  }, [closedRoads, roads]);
  useEffect(() => {
    var iconFeature = new Feature({
      geometry: new Point(
        transform([8.76038702, 39.00008797], "EPSG:4326", "EPSG:3857")
      ),
      population: 4000,
      rainfall: 500,
    });
    var vectorSource1 = new VectorSource({
      features: [iconFeature],
      style: new Style({
        image: new Icon({
          anchorXUnits: "fraction",
          anchorYUnits: "fraction",
          src: "6.png",
        }),
      }),
    });

    var vectorLayer1 = new VectorLayer({
      source: vectorSource1,
      projection: 'EPSG:4326',
      zIndex: 10000,
    });
    window.initialMap.addLayer(vectorLayer1);
  }, []);
  useEffect(() => {
    console.log("lll", pathUrls)

    if (pathUrls.length != 0) {
      for (let index = 0; index < pathUrls.length; index++) {
        const element = pathUrls[index];
        if (element.data != undefined && element.data.length == 0) {
          setOpenRoad(true);
        }

        if (element.data != undefined)
          props.setPath_datas([...props.path_datas, ...element.data]);
      }
    }

    // drawDirection(pathUrls);
  }, [pathUrls]);
  useEffect(() => {
    window.initialMap.un("singleclick", handleSelectClick);
    pickLocationSource.clear(true);
    setPickedLocation(null);
    if (props.activeTab !== "DIRECTION") {
      window.initialMap.on("singleclick", handleSelectClick);
    }
  }, [props.activeTab]);
  useEffect(() => {
    window.initialMap.un("singleclick", handleDirectionClick);
    startLocationRef.current = null;
    if (props.activeTab === "DIRECTION") {
      window.initialMap.on("singleclick", handleDirectionClick);
    }
  }, [props.activeTab]);
  useEffect(() => {
    if (activePlace) {
      window.initialMap.getView().animate({
        center: activePlace,
        duration: 1000,
        zoom: 20,
      });
    }
  }, [activePlace]);
  useEffect(() => {
    window.initialMap.getLayers().forEach((layer) => {
      if (layer instanceof VectorLayer) {
        window.initialMap.removeLayer(layer);
      }
    });
    window.popupOverlay.setPosition(undefined);
  }, [props.activeTab]);
  const handleSelectClick = useCallback((e) => {
    const coordinate = e.coordinate;
    const feature = new Feature({
      geometry: new Point(coordinate),


    });

    console.log("kkkkkkkkkk", handleSelectClick);

    pickLocationSource.clear(true);
    pickLocationSource.addFeature(feature);
    const layer = new VectorLayer({
      source: pickLocationSource,
      projection: 'EPSG:4326',
      style: new Style({
        image: new Icon({
          scale: 0.6,
          anchorXUnits: "fraction",
          anchorYUnits: "fraction",
          src: "red.png",
        }),
      }),
      zIndex: 10000,
    });
    window.initialMap.addLayer(layer);
    setPickedLocation(coordinate);
    window.initialMap.getView().animate({
      center: coordinate,
      duration: 750,
    });
  }, []);
  var featureLayer = new LayerGroup({
    layers: [],
    name: "markerGroup",
  });
  useEffect(() => {
    console.log("lll", pathUrls)
    if (pathUrls != undefined) {
      if (props.path_datas.length != 0) {
        console.log("llll", props.path_datas.length)
        var speed = 0;
        var speed1;
        var speed2;
        var speed3;
        var const1 = 0;
        var const2 = 0;
        var const3 = 0;
        var coordinate1x1;
        var coordinate2x2;
        var coordinate3x3;
        var coordinate1y1;
        var coordinate2y2;
        var coordinate3y3;
        if (props.path_datas.length != 0) {
          let num = window.initialMap.getLayers().getLength();
          while (num > 2) {
            window.initialMap.getLayers().pop();
            num--;
          }
          if (props.activeInnerTab == "CAR") {
            speed = 60;
          } else if (props.activeInnerTab == "BIKE") {
            speed = 25;
          } else if (props.activeInnerTab == "WALK") {
            speed = 4;
          }
          var mid = props.path_datas.length / 2;
          mid = mid.toFixed(0);
          coordinate2x2 =
            props.path_datas[props.path_datas.length - 1].geometry
              .coordinates[0][0];
          coordinate2y2 =
            props.path_datas[props.path_datas.length - 1].geometry
              .coordinates[0][1];
          coordinate1x1 = props.path_datas[0].geometry.coordinates[0][0];
          coordinate1y1 = props.path_datas[0].geometry.coordinates[0][1];
          for (let i = 1; i < props.path_datas.length; i++) {
            const element = props.path_datas[i];
            if (element != []) {
              var pathSeq = element.properties.path_id;
              if (pathSeq != "1") {
                const2 += element.properties.cost / 1000;
                speed2 = const2 / speed;

                // convert to minutes (as a number)
                // speed2 = (speed2).toFixed(0);
                speed2 = (speed2 * 60).toFixed(0);

                if (speed2 < 1) {
                  // Convert to seconds if less than 1 minute
                  const seconds = Math.round((const2 / speed) * 60);
                  speed2 = `${seconds} sec`;
                } else if (speed2 >= 60) {
                  const hours = Math.floor(speed2 / 60);       // Whole hours
                  const minutes = Math.round(speed2 % 60);     // Remaining minutes
                  // speed2 = `${hours}h and ${minutes}min`;
                  speed2 = ""
                } else {
                  // Show in minutes
                  speed2 = `${speed2} min`;
                }

              } else if (pathSeq == "1") {
                const1 += element.properties.cost / 1000;
                speed1 = const2 / speed;
                speed1 = (speed1).toFixed(0);

                if (speed1 < 1) {
                  const seconds = Math.round((const2 / speed) * 60);
                  speed1 = `${seconds} sec`;
                } else if (speed1 >= 60) {
                  const hours = Math.floor(speed1 / 60);
                  const minutes = Math.round(speed1 % 60);
                  speed1 = `${hours}h and ${minutes}min`;
                } else {
                  speed1 = `${speed1} min`;
                }
              }
            }
          }

          if (const2 < 1) {
            const1 = const1 * 1000;
            const1 = Number(const1.toFixed(2)) + "m";
          } else {
            const1 = Number(const1.toFixed(2)) + "km";
          }
          if (const2 < 1) {
            const2 = const2 * 1000;
            const2 = Number(const2.toFixed(2)) + "m";
          } else {
            const2 = Number(const2.toFixed(2)) + "km";
          }
        }
        const length = pathUrls.length - 1;
        startLocationRef.current = null;
        window.initialMap.getLayers().forEach((layer) => {
          if (layer instanceof VectorLayer) {
            window.initialMap.removeLayer(layer);
          }
        });
        for (const [idx, path] of pathUrls.entries()) {
          const source = new VectorSource({
            format: new GeoJSONFormat(),
            url: path.url,
          });
          const layer = new VectorLayer({
            source,
            projection: 'EPSG:4326',
            style: function (feature) {
              const pathId = feature.get("path_id");
              let color = "#13f016";
              if (pathId == "1") {
                color = "#13f016";
              } else if (pathId != "1") {
                https://www.google.com/maps/@9.0200229,38.7627725,16z?entry=ttu&g_ep=EgoyMDI1MDczMC4wIKXMDSoASAFQAw%3D%3D
                color = "#1A8F1E";
              }
              return new Style({
                stroke: new Stroke({
                  color: color,
                  width: 6,
                  opacity: 0.6,
                }),
              });
            },
            tile: true,
            zIndex: 10005,
          });
          if (idx === 0) {
            // Create start point feature
            const feature = new Feature({
              geometry: new Point([
                path.startLocation.coordinates[0],
                path.startLocation.coordinates[1],
              ]),
            });

            // Clear previous start marker
            startMarkerSource.clear(true);
            startMarkerSource.addFeature(feature);

            // Create vector layer for the start marker
            const layer = new VectorLayer({
              source: startMarkerSource,
              projection: 'EPSG:4326',
              style: new Style({
                image: new Icon({
                  scale: 0.6,
                  anchorXUnits: "fraction",
                  anchorYUnits: "fraction",
                  src: "blue.png", // marker icon
                }),
                text: new Text({
                  font: "Normal 16px Arial",
                  //text: `Total Distance is${const2} \n${speed2}`,   // <-- no hardcoded "min"
                  text: t('TotalDistance', { distance: const2 }),
                  fill: new Fill({
                    color: "#07490dff", // text color
                  }),
                  stroke: new Stroke({
                    color: "#ffffff", // text outline
                    width: 3,
                  }),
                  backgroundFill: new Fill({
                    color: "#ffffff", // background color behind text
                  }),
                  backgroundStroke: new Stroke({
                    color: "#b8b7b7ff", // border color around background
                    width: 2, // border width
                  }),
                  padding: [3, 6, 3, 6], // top, right, bottom, left padding
                  offsetX: 65, // horizontal offset
                  offsetY: -45, // vertical offset
                }),

              }),
              zIndex: 10010,
            });

            // Add layer to the map
            window.initialMap.addLayer(layer);
          }
          else {
            const feature = new Feature({
              geometry: new Point(path.startLocation.coordinates),
            });
            const layer = new VectorLayer({
              source: new VectorSource({
                features: [feature],
              }),
              projection: 'EPSG:4326',
              style: new Style({
                image: new CircleStyle({
                  radius: 6,
                  fill: new Fill({
                    color: "#00695c",
                  }),
                }),
                text: new Text({
                  font: "Normal 16px Arial",
                  text: `Tolal${const2} ${speed2}`,
                  fill: new Fill({
                    color: "#fff",
                  }),
                  stroke: new Stroke({
                    color: "#000000",
                    width: 3,
                  }),
                  zIndex: 999999999,
                  offsetX: -45,
                  offsetY: 0,
                  rotation: 0,
                }),
              }),
              zIndex: 10008,
            });
            window.initialMap.addLayer(layer);
          }
          if (idx === length) {
            const feature = new Feature({
              geometry: new Point([
                path.endLocation.coordinates[0],
                path.endLocation.coordinates[1],
              ]),
            });
            endMarkerSource.clear(true);
            endMarkerSource.addFeature(feature);
            const layer = new VectorLayer({
              source: endMarkerSource,
              projection: 'EPSG:4326',
              style: new Style({
                image: new Icon({
                  scale: 1.4,
                  anchorXUnits: "fraction",
                  anchorYUnits: "fraction",
                  src: "flag.png",
                }),

              }),
              zIndex: 10010,
            });
            window.initialMap.addLayer(layer);
          }
          window.initialMap.addLayer(layer);
        }
        var num = window.initialMap.getLayers().getLength();
        console.log("this is new layers", num);
      }
    }
  }, [props.path_datas, props.activeInnerTab]);

  const handleDirectionClick = useCallback((e) => {
    console.log("hey this is clicked")
    const coordinate = e.coordinate;
    if (startLocationRef.current) {
      const feature = new Feature({
        geometry: new Point(coordinate),
      });
      endMarkerSource.clear(true);
      endMarkerSource.addFeature(feature);

      const layer = new VectorLayer({
        source: endMarkerSource,
        projection: 'EPSG:4326',
        style: new Style({
          image: new Icon({
            scale: 1.4,
            anchorXUnits: "fraction",
            anchorYUnits: "fraction",
            src: "flag.png",
          }),
        }),
      });
      window.initialMap.addLayer(layer);
      console.log("hey", startLocationRef.current)
      dispatch(
        setLocationStart({
          start: startLocationRef.current,
          end: coordinate,
        })
      );
      startLocationRef.current = null;
    } else {
      window.initialMap.getLayers().forEach((layer) => {
        if (layer instanceof VectorLayer) {
          window.initialMap.removeLayer(layer);
        }
      });

      startLocationRef.current = coordinate;
      const feature = new Feature({
        geometry: new Point(coordinate),
      });

      startMarkerSource.clear(true);
      endMarkerSource.clear(true);
      startMarkerSource.addFeature(feature);

      const layer = new VectorLayer({
        source: startMarkerSource,
        projection: 'EPSG:4326',
        style: new Style({
          image: new Icon({
            scale: 0.6,
            anchorXUnits: "fraction",
            anchorYUnits: "fraction",

            src: "blue.png",
          }),
        }),
      });
      window.initialMap.addLayer(layer);
    }
  }, []);


  useEffect(() => {
    const query = queryString.parse(window.location.search, {
      parseNumbers: true,
    });
    if (query.lat && query.lng) {
      const feature = new Feature({
        geometry: new Point([query.lng, query.lat]),
      });
      pickLocationSource.clear(true);
      pickLocationSource.addFeature(feature);
      const layer = new VectorLayer({
        source: pickLocationSource,
        projection: 'EPSG:4326',
        style: new Style({
          image: new Icon({
            scale: 0.6,
            anchorXUnits: "fraction",
            anchorYUnits: "fraction",
            src: "red.png",
          }),
        }),
      });

      window.initialMap.addLayer(layer);
    }
  }, []);

  useEffect(() => {
    const query = queryString.parse(window.location.search, {
      parseNumbers: true,
    });

    dispatch(
      setSharedLocationStart({
        query,
      })
    );
  }, []);

  useEffect(() => {
    /**
     * Disable browser context menu
     */
    window.initialMap.on("contextmenu", function (e) {
      e.preventDefault();
    });
  }, []);

  return (
    <div>
      <div ref={mapElement} className="map-container"></div>
        {/* Language switcher (EN / AM) */}

<FormControl
  sx={{
    position: "absolute",
    bottom: 10,
    right: 0,
    zIndex: 9999,
    background: "#fff",
    borderRadius: 3,
    boxShadow: "0 4px 10px rgba(0,0,0,0.3)",
    minWidth: 160
  }}
>
  <Select
    value={i18n.language || "en"}
    onChange={(e) => setLanguage(e.target.value)}
    size="small"
  >
    <MenuItem value="en">English</MenuItem>
    <MenuItem value="am">አማርኛ</MenuItem>
    <MenuItem value="or">Afaan Oromoo</MenuItem>
    <MenuItem value="tig">ትግርኛ</MenuItem>
    <MenuItem value="had">ሀደርኛ</MenuItem>
        <MenuItem value="hadf">.</MenuItem>

  </Select>
</FormControl>


      <div id="popup" className="ol-popup">
        {/* style={{maxWidth:"200px",maxHeight:"200px"}} */}
        <a href="#" id="popup-closer" className="ol-popup-closer"></a>
        <div id="popup-content"></div>
        <Box
          id="empty-feature"
          sx={{
            display: "none",
            flexDirection: "column",
            alignItems: "center",
            gap: "10px",
          }}
        >
          <Typography variant="body1" sx={{ color: "#909090" }}>
            {t('NoFeaturesFound')}
                      {t('AddAPlace')}
          </Typography>
          <Button
            id="add-place"
            color="primary"
            size="small"
            sx={{
              backgroundColor: "#04B2B2",
              paddingLeft: "10px",
              paddingRight: "10px",
              color: "#FFFFFF",
              "&:hover": {
                backgroundColor: "#04B2B2",
              },
            }}
          >
            Add a Place
          </Button>
        </Box>
        <Accordion id="popup-accordion">
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2a-content"
            id="panel2a-header"
          >
            <Typography>{t('SeeMore')}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              <div id="details"></div>
            </Typography>
          </AccordionDetails>
        </Accordion>
      </div>

      {/* Fullscreen image viewer for popup images */}
      <div
        id="image-viewer"
        style={{
          display: "none",
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          background: "rgba(0,0,0,0.85)",
          zIndex: 2147483647,
          justifyContent: "center",
          alignItems: "center",
          display: "none",
        }}
      >
        <img
          id="image-viewer-img"
          alt="Full view"
          style={{
            maxWidth: "90%",
            maxHeight: "90%",
            borderRadius: "6px",
            boxShadow: "0 6px 30px rgba(0,0,0,0.5)",
          }}
        />
        <button
          id="image-viewer-close"
          style={{
            position: "absolute",
            top: 20,
            right: 20,
            background: "transparent",
            border: 0,
            color: "#fff",
            fontSize: 28,
            cursor: "pointer",
          }}
        >
          ✕
        </button>
      </div>

      {pickedLocation ? (
        <ShareLocation pickedLocation={pickedLocation} />
      ) : null}

      {mapInstance && <GoogleLayerSwitcher map={mapInstance} />}
      {pathUrls.length >= 1 ? <ShareRoute pathUrls={pathUrls} /> : null}

      <Stack spacing={2} sx={{ width: "100%" }}>
        <Snackbar
          open={openRoad}
          autoHideDuration={4000}
          sx={{ paddingLeft: "80%" }}
          onClose={handleCloseRoad}
        >
          <Alert
            onClose={handleCloseRoad}
            severity="success"
            sx={{ width: "100%" }}
          >
            {t('NoRoadBetween')}
          </Alert>
        </Snackbar>
      </Stack>
    </div>
  );
};
